import React from 'react';
import { Reveal } from './Section';
type Stat = {
  value: string;
  icon: string;
  label: string;
};
const stats: Stat[] = [{
  value: '+500',
  icon: '👥',
  label: 'Inversores confían'
}, {
  value: '6+6',
  icon: '📚',
  label: 'Tomos + bonos'
}, {
  value: '4.9/5',
  icon: '⭐',
  label: 'Calificación'
}, {
  value: '🇦🇷',
  icon: '',
  label: 'Todo el país'
}];
export function StatsBar() {
  return <section aria-label="Estadísticas de Capital Consciente" className="w-full border-b border-white/5 bg-ink-950 px-5 py-8 sm:py-10" data-id="element-250" data-mp="1edh9126p8oq8">
      <Reveal data-id="element-251" data-mp="19l7ok1ocsgvc">
        <div className="mx-auto grid w-full max-w-4xl grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-252" data-mp="19ko6mkypdshb">
          {stats.map(stat => <div key={stat.label} className="rounded-xl border border-brand/30 bg-black px-4 py-5 text-center sm:px-5" data-id="element-253" data-mp="10lt0f8vnsie0">
              <p className="font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-id="element-254" data-mp="vn9dp698r2kl">
                {stat.value}
              </p>
              <p className="mt-2 text-[10px] font-semibold uppercase tracking-wide text-amber-400 sm:text-xs" data-id="element-255" data-mp="qoeui37d3bzy">
                {stat.icon && <span aria-hidden="true" data-id="element-256" data-mp="3teu13j07hj9f">{stat.icon} </span>}
                {stat.label}
              </p>
            </div>)}
        </div>
      </Reveal>
    </section>;
}